/**
 * Created by zzy on 2019/8/15.
 */
import { loadRegionTree, loadStreamNodeTreeItems } from 'utils/tree'
import { setStore, getStore } from 'utils/storage'
import {getRegionList} from '@/api/get-data.js'
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import typeImageMixin from '@/mixins/type-image-mixin.js' // 引入mixin文件

export default {
  name: 'ModifyVideoPatrol',
  data () {
    return {
      // 树数据
      treeData: [],
      // 树节点已加载的区域id数组
      treeNodeLoadedRegionIds: [],
      checkedTreeData: [],
      checkedKeys: [],
      treeExpandedKeys: [], // 默认展开树节点key
      // 查询条件
      queryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 轮巡信息
      totalStreamNodeCount: 0,
      patrolInterval: 30
    }
  },
  props: {
    modalOpen: {
      type: Boolean,
      default: false
    },
    videoPatrolActive: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    convertorMixin,
    typeImageMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  mounted () {
    // 获取区域列表
    this.getRegionList2()

    // 打开上一次的打开视频
    setTimeout(() => {
      // 恢复视频节点勾选状态
      let videoPatrolCheckedStreamNodes = getStore('videoPatrolCheckedStreamNodes')
      let videoPatrolCheckedStreamNodeKeys = getStore('videoPatrolCheckedStreamNodeKeys')
      if (videoPatrolCheckedStreamNodes !== null && videoPatrolCheckedStreamNodeKeys !== null) {
        try {
          this.checkedTreeData = JSON.parse(videoPatrolCheckedStreamNodes)
          this.checkedKeys = JSON.parse(videoPatrolCheckedStreamNodeKeys)
        } catch (e) {
        }
      }
    }, 500)
  },
  methods: {
    // 查询区域列表
    getRegionList2() {
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)
        if (this.treeData.length > 0) {
          // 查询顶层区域下的视频节点列表
          this.getStreamNodeList(this.treeData[0].id)
          // 默认展开根节点
          this.treeExpandedKeys = [this.treeData[0].key]
        }
      })
    },
    // 查询视频节点列表
    getStreamNodeList(regionId) {
      // 检测该区域下视频节点是否已加载，防止重复加载
      if (this.treeNodeLoadedRegionIds.indexOf(regionId) !== -1) {
        return
      }

      this.$http(this.$api.streamNodeList, {
        regionId: regionId,
        streamServerInfoRequired: 1, // 需获取流媒体服务信息
        pageNum: 1,
        pageSize: 1000
      }).then(
        res => {
          if (res.code === 200) {
            if (res.data.length) {
              this.treeData = loadStreamNodeTreeItems(res.data, this.treeData)
              if (this.$refs.tree.currentNode && this.treeExpandedKeys.indexOf(this.$refs.tree.currentNode.node.key) === -1) {
                this.treeExpandedKeys.push(this.$refs.tree.currentNode.node.key) // 展开父区域
              }
            }
            this.treeNodeLoadedRegionIds.push(regionId)
            this.totalStreamNodeCount += res.data.length
          }
        }
      )
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick (obj) {
      if (obj.type === 'region') {
        this.getStreamNodeList(obj.id)
      } else if (obj.type === 'streamNode') {
      }
    },
    // 勾选树节点
    handleTreeNodeCheck (nodeObj, e) {
      this.checkedTreeData = []
      e.checkedNodes.forEach(item => {
        if (item.type === 'streamNode') {
          this.checkedTreeData.push(item)
        }
      })
      this.checkedKeys = e.checkedKeys
    },
    // 开始视频轮巡
    startVideoPatrol () {
      if (this.checkedTreeData.length <= 0) {
        this.$warning({
          title: '提示',
          content: '请勾选参与轮巡的视频节点！',
          okText: '知道了'
        })
        return
      }

      this.$emit('startVideoPatrol', {
        checkedStreamNodes: this.checkedTreeData,
        patrolInterval: this.patrolInterval
      })

      // 保存视频轮巡状态
      this.saveVideoPatrolState()
    },
    // 停止视频轮巡
    stopVideoPatrol () {
      this.$emit('stopVideoPatrol')
    },
    // 关闭窗口
    handleModalCancel () {
      this.$emit('closeVideoPatrolModal')
    },
    // 保存视频轮巡状态
    saveVideoPatrolState () {
      setStore('videoPatrolCheckedStreamNodes', this.checkedTreeData)
      setStore('videoPatrolCheckedStreamNodeKeys', this.checkedKeys)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/monitoring/liveVideo/modifyVideoPatrol/ModifyVideoPatrol.js